import React from "react";
import { connect } from "react-redux";
import { defaultAction } from "@actions/defaultAction";

import { SHOW_NEW_BUY_MODAL, SET_SLUG_NEW_BUY } from "@constants/actionTypes";
import styled from "@emotion/styled";

const Container = styled.div`
  width: 100%;
  height: 140px;
  box-shadow: 0 20px 80px 0 rgba(119, 121, 132, 0.1);
  background-color: #ffffff;
  display: grid;
  cursor: pointer;
  &:hover {
    box-shadow: 0 60px 80px 0 rgba(119, 121, 132, 0.3);
  }
  @media (max-width: 1400px) {
    height: 126px;
  }
  @media (max-width: 1300px) {
    height: 149px;
  }
  @media (max-width: 1030px) {
    height: 135px;
  }
  @media (max-width: 925px) {
    height: 149px;
  }
  @media (max-width: 850px) {
    height: 135px;
  }
  @media (max-width: 700px) {
    height: 116px;
  }
  @media (max-width: 575px) {
    height: 149px;
  }
  @media (max-width: 500px) {
    height: 135px;
  }
  @media (max-width: 400px) {
    height: 122px;
  }
  @media (max-width: 355px) {
    height: 109px;
  }
`;

const InnerDiv = styled.div`
  position: relative;
`;

const ImageDiv = styled.div`
  position: absolute;
  top: -47px;
  width: 100%;
  text-align: center;
  @media (max-width: 450px) {
    top: -41px;
  }
`;

const Image = styled.img`
  width: 139px;
  height: 90px;
  box-shadow: 0 22px 32px 0px rgba(119, 121, 132, 0.15);
  @media (max-width: 1750px) {
    width: 66%;
    height: auto;
  }
`;

const NameDiv = styled.div`
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  color: #1f2021;
  position: relative;
  top: 32px;
`;

const NewCard = ({ slug, img, brand, openModal, setSlug }) => {
  const nameLength = brand.length;
  const nameSize =
    nameLength > 30 ? "xLarge" : nameLength > 20 ? "large" : "regular";
  const handleClick = () => {
    openModal(true);
    setSlug(slug);
  };
  return (
    <Container
      onClick={handleClick}
      className="button-transition-hover-boxShadow"
    >
      <InnerDiv>
        <ImageDiv>
          <Image src={img} alt={`${brand} Gift Card`} />
          <div>
            <NameDiv className={`discount-card-name-div-${nameSize}`}>
              {brand}
            </NameDiv>
          </div>
        </ImageDiv>
      </InnerDiv>
    </Container>
  );
};

export default connect(null, dispatch => ({
  openModal: e => dispatch(defaultAction(SHOW_NEW_BUY_MODAL, e)),
  setSlug: e => dispatch(defaultAction(SET_SLUG_NEW_BUY, e))
}))(NewCard);
